export enum HraPreferredName {
    HRA = 'HRA',
    HA = 'HA'
}
